import { createFileRoute, getRouteApi } from "@tanstack/react-router"

import { TeamSectionPage } from "@/app/components/team-section-page"

const shellRoute = getRouteApi("/_app-shell")

export const Route = createFileRoute("/_app-shell/team/$orgId/$section")({
  head: () => ({ meta: [{ title: "Team - Kestly" }] }),
  component: function TeamSectionRoute() {
    const { teams } = shellRoute.useLoaderData()
    const { orgId, section } = Route.useParams()
    return <TeamSectionPage teams={teams} orgId={orgId} section={section} />
  },
})
